import { getSum } from '../../../utilities/getSum';
import { checkIntegralKind } from './checkIntegralKind';
import { mapValues } from './mapValues';
export function updateIntegralsRelativeValues(spectrum, forceCalculateIntegral = false) {
    const { values, options } = spectrum.integrals;
    const currentSum = getSum(values, 'absolute', checkIntegralKind);
    let factor = 0;
    if (options?.sum) {
        if (options.isSumConstant || forceCalculateIntegral) {
            factor = currentSum > 0 ? options.sum / currentSum : 0;
        }
        else if (values?.[0]) {
            const item = values[0];
            factor = (item.integral || options.sum) / item.absolute;
        }
    }
    spectrum.integrals.values = mapValues(values, 'integral', factor, checkIntegralKind);
    if (!options.isSumConstant && !forceCalculateIntegral) {
        options.sum = getSum(values, 'integral', checkIntegralKind);
    }
}
//# sourceMappingURL=updateIntegralsRelativeValues.js.map